const getGa = () => {
  if (!('ga' in window)) {
    console.warn('Google analytics not initiated yet');
    return null;
  }

  return window.ga;
};

/**
 *
 * @param {string} category
 * @param {string} action
 * @param {string} label
 * */
// eslint-disable-next-line import/prefer-default-export
export const captureEvent = (category, action, label) => {
  const ga = getGa();

  if (!ga) {
    return;
  }

  ga('send', 'event', category, action, label);
};
